import { Box, Button, Divider, Link, Stack, Typography } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
const closeAccountButtons = [
  { color: "#FDDF59", bgcolor: "#272727", label: "Keep My Account" },
  { color: "#ffffff", bgcolor: "#D6293E", label: "Delete My Account" },
];

function CloseAccountSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "500px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Delete account"
        secondary="He moonlights difficult engrossed it, sportsmen. Interested has all Devonshire difficulty gay assistance joy. Unaffected at ye of compliment alteration to."
      />
      <TopHeadingDividerComponent
        primary="Before you go ..."
        primaryBottomPadding="8px"
        primaryTopPadding="8px"
        divider={false}
        secondary={
          <Stack spacing={0.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {" "}
              <Box
                sx={{
                  width: "6px",
                  height: "6px",
                  bgcolor: "#000000",
                  borderRadius: "50%",
                }}
              ></Box>
              Take a backup of your data 
              <Link
                sx={{
                  color: "#111111",
                  textDecorationColor: "#111111", // Set underline color to black
                  "&:hover": {
                    textDecorationColor: "#111111", // Keep underline black on hover
                  },
                  cursor: "pointer",
                }}
              >
                Here
              </Link>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {" "}
              <Box
                sx={{
                  width: "6px",
                  height: "6px",
                  bgcolor: "#000000",
                  borderRadius: "50%",
                }}
              ></Box>
              If you delete your account, you will lose your all data.
            </Box>
          </Stack>
        }
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "21.78px",
          ml: "-6px",
          pt: "8px",
        }}
      >
        Yes, I'd like to delete my account
      </Typography>
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          border: "none",
          mx: "-20px",
          my: "24px",
        }}
      />
      <Box sx={{ display: "flex", gap: "16px", alignSelf: "end" }}>
        {closeAccountButtons.map((btn) => (
          <Button
            variant="text"
            sx={{
              color: btn.color,
              textTransform: "none",
              width: "auto",
              bgcolor: btn.bgcolor,
              borderRadius: "60px",
              py: "10px",
              fontSize: "15px",
              px: "32px",
            }}
          >
            {btn.label}
          </Button>
        ))}
      </Box>
    </Stack>
  );
}

export default CloseAccountSection;
